import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { LoginService } from './login.service';
import { of, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

/**
 * AuthGuardService
 *
 * @export AuthGuardService
 */
@Injectable({
  providedIn: 'root',
})
export class AuthGuardService {
  /**
   * Creates an instance of AuthGuardService.
   * @param auth loginService used for authoriser
   * @param router used for route navigation
   */
  constructor(
    public auth: LoginService,
    public router: Router,
  ) {}

  /**
   * Auth checking using the loginService
   *
   * @returns true or false depending on if user is currently logged in
   */
  canActivate(
    next?: ActivatedRouteSnapshot,
    state?: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.auth.checkLogin().pipe(
      map(e => {
        if (e) {
          return true;
        } else {
          this.router.navigate(['login']);
          return false;
        }
      }),
      catchError(err => {
        this.router.navigate(['login']);
        return of(false);
      }),
    );
  }
}
